import { MetaReducer, Action } from '@ngrx/store';
import { provideState } from '@ngrx/store';
import { provideEffects } from '@ngrx/effects';
import { AuthenticationEffects } from './state/effects/authentication.effects';
import { AuthenticationReducer, AuthenticationState } from './state/reducer/authentication.reducer';
import { authenticationStateKey } from './state';
import { AuthenticationFacade } from './facade/authentication.facade';
import { createLocalStorageSyncReducer } from '../../shared/utils/local-storage-sync';

const localStorageSyncReducer = createLocalStorageSyncReducer<AuthenticationState>(['user']);

const metaReducers: Array<MetaReducer<AuthenticationState, Action>> = [localStorageSyncReducer];

export const authenticationConfig = [
  provideState(authenticationStateKey, AuthenticationReducer, { metaReducers }),
  provideEffects([AuthenticationEffects]),
  AuthenticationFacade,
];